import styled from "styled-components";

export const ConsentimentoContainer = styled.div({
  display: "flex",
  flexDirection: "column",
  marginBottom: "20px",
});
